"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_APPLICATION_RATE = void 0;
exports.DEFAULT_APPLICATION_RATE = 10;
